import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { auditThemeService } from '../../services/auditThemeService';
import './AuditThemeSelector.css';

const AuditThemeSelector = ({ hospitalId, value = [], onChange, disabled }) => {
  const { t } = useTranslation(['qms', 'common']);
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!hospitalId) {
        setThemes([]);
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const list = await auditThemeService.getThemes(hospitalId);
        if (!cancelled) setThemes(list);
      } catch (e) {
        console.error('[AuditThemeSelector]', e);
        if (!cancelled) setThemes([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [hospitalId]);

  const toggle = (theme) => {
    if (disabled) return;
    const id = theme.id;
    const isOn = value.includes(id);
    let newIds;
    let newLabels;
    if (isOn) {
      newIds = value.filter((x) => x !== id);
      newLabels = themes.filter((th) => newIds.includes(th.id)).map((th) => th.label);
    } else {
      newIds = [...value, id];
      newLabels = themes.filter((th) => newIds.includes(th.id)).map((th) => th.label);
    }
    onChange?.(newIds, newLabels);
  };

  if (loading) {
    return <div className="audit-theme-selector loading">{t('qms:loadingThemes')}</div>;
  }

  if (!themes.length) {
    return <div className="audit-theme-selector empty">{t('qms:noThemesAvailable')}</div>;
  }

  return (
    <div className="audit-theme-selector" role="group" aria-label={t('qms:auditThemes')}>
      <div className="audit-theme-chips">
        {themes.map((theme) => {
          const selected = value.includes(theme.id);
          return (
            <button
              key={theme.id}
              type="button"
              className={`audit-theme-chip ${selected ? 'selected' : ''}`}
              onClick={() => toggle(theme)}
              disabled={disabled}
              aria-pressed={selected}
            >
              {theme.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AuditThemeSelector;
